import { render, staticRenderFns } from "./RelatorioEstoque.vue?vue&type=template&id=3f8b1920&"
import script from "./RelatorioEstoque.vue?vue&type=script&lang=js&"
export * from "./RelatorioEstoque.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioEstoque.vue?vue&type=style&index=0&id=3f8b1920&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports